import { ArraySchema, ValidationError } from "yup";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ArrayType = any[] | null | undefined;

export function unique<TIn extends ArrayType, TContext, TDefault = undefined>(
  this: ArraySchema<TIn, TContext, TDefault>,
  message: string,
  mapper: string,
) {
  return this.test("unique", message, function (list: any) {
    const uniqueIds: any = [];

    list.filter((element: any) => {
        if(element.param_key) {
            const isDuplicate = uniqueIds.includes(element.param_key);
            if (!isDuplicate) {
              uniqueIds.push(element.param_key);
              return true;
            } else {
              uniqueIds.push('');
              return false;
            }
        }
    });

    const errors = uniqueIds.map((param_key: string, index: number) => {
      if (param_key === '') {
        return this.createError({
          path: `${this.path}.${index}.param_key`,
          message
        });
      } 
    });
    return new ValidationError(errors);
  })
}

declare module "yup" {
  interface ArraySchema<TIn extends ArrayType, TContext, TDefault = undefined> {
    unique(message: string, mapper?: (value: TContext, index?: number, list?: TIn[]) => TIn[]): ArraySchema<TIn, TContext, TDefault>;
  }
}
